module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"share":"Share my current location","update":"Update location"},"nl":{"share":"Deel mijn huidige locatie","update":"Locatie bijwerken"}}')
  delete Component.options._Ctor
}
